import React, { useEffect } from 'react';
import styles from './index.module.scss';
import { useTrackingContext } from '../../../hooks';
import InviteBanner from '../../InviteBanner';

const TAB_COLORS = [
  { varName: '--bfi-yellow', text: '#000' },
  { varName: '--bfi-orange', text: '#000' },
  { varName: '--bfi-deep-pink', text: '#fff' },
  { varName: '--bfi-fuchsia', text: '#000' },
  { varName: '--bfi-green-yellow', text: '#000' },
  { varName: '--bfi-dodger-blue', text: '#000' },
  { varName: '--bfi-blue-violet', text: '#fff' },
  { varName: '--bfi-cyan', text: '#000' },
  { varName: '--bfi-lime', text: '#000' },
];

const Tabs = ({
  zones,
  tabIndex,
  animateToTab,
  isWeb,
  canShowInviteBanner,
}) => {
  const { trackContentAction } = useTrackingContext();

  // Auto-scroll tab into view when tab changes
  useEffect(() => {
    const tabEl = document.querySelectorAll(`.${styles.tab}`)[tabIndex];
    if (tabEl) {
      const { left, right } = tabEl.getBoundingClientRect();
      const isOffScreen = left < 0 || right > window.innerWidth;
      if (isOffScreen) {
        tabEl.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        });
      }
    }
  }, [tabIndex]);

  const onTabClick = (index) => {
    // Use carousel animation for tab changes
    if (animateToTab && index !== tabIndex) {
      const targetZone = zones[index];

      trackContentAction({
        unit_type: 'nav',
        unit_name: 'tabs',
        item_type: 'button',
        item_name: targetZone?.name,
        position_in_unit: index,
        action_type: 'select',
        action_value: targetZone?.name,
      });

      animateToTab(index);
    }
  };

  return (
    <div
      className={`${styles.headerContainer} ${isWeb ? styles.web : ''}`}
    >
      {canShowInviteBanner && (
        <InviteBanner variant="creationLander" />
      )}

      <div className={styles.slidingContainer}>
        {/* Tabs - slide left when search opens */}
        <div
          className={styles.tabsView}
        >
          <div className={styles.tabs}>
            {zones.map((zone, index) => (
              <button
                className={`${styles.tab} ${tabIndex === index ? styles.selected : ''} ${!isWeb ? styles.extraMargin : ''}`}
                onClick={() => onTabClick(index)}
                key={index}
                type="button"
                style={
                  tabIndex === index
                    ? {
                        '--tab-bg': `var(${TAB_COLORS[index % TAB_COLORS.length].varName})`,
                        '--tab-text':
                          TAB_COLORS[index % TAB_COLORS.length].text,
                      }
                    : {}
                }
              >
                {zone.display_name}
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Tabs;
